import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './assets/css/App.css';

import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { ChakraProvider } from '@chakra-ui/react';
// import './i18n';
import { RegionDataProvider } from 'contexts/RegionDataContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store} >
    <ChakraProvider>
      <RegionDataProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </RegionDataProvider>
    </ChakraProvider>
  </Provider>,
);
